<template>
    <div>
        <base-list :collection='collection' selectable selectMode="multi" @rowSelected='selectedItems => selected = selectedItems' :loading='loading' :fields='currentFields' :modalObject='currentModalObject' @pageChanged='pageChanged'>
            
			<template v-slot:cell(item)='data'>
                <div v-if='data.item.item'>    
                    {{ data.item.item.name }}
                </div>

                <div v-if='data.item.start_date' class="badge badge-success ml-2">
                    from
                    <i class='fa fa-calendar'></i>
                    {{ data.item.start_date }}
                </div>
                <div v-if='data.item.end_date' class="badge badge-success ml-2">
                    to
                    <i class='fa fa-calendar'></i>
                    {{ data.item.end_date }}
                </div>
                <br>
                <div class='badge badge-light mt-2'>
                    {{ data.item.entity_saleable.description }}
                </div>
            </template>

            <template v-slot:cell(entity)='data'>
                <div>
                    {{ data.item.entity_saleable.entity.name }}
                </div>
            </template>

        </base-list>
    </div>
</template>

<script>
import BaseList from './BaseList.vue';
import BaseListMethods from './BaseListMethods';

export default {
	props: ['viewType'],
    components: { BaseList },
    extends: BaseListMethods,
    data() {
        return {
            selected: [],
			fields: [
                { key: 'entity', label: 'Entity' },
                { key: 'item', label: 'Item' },
                { key: 'direction', label: 'Direction' },
                { key: 'status', label: 'Status' },
                { key: 'total_quantity', label: 'Total Quantity' },
                { key: 'used_quantity', label: 'Used Quantity' },
                { key: 'remaining_quantity', label: 'Remaining Quantity' },
			]
        }
    },
	methods: {
        load: function (apiClient, cancelToken, filter) {
			return apiClient.get('entity-saleable-items', filter, cancelToken);
		}
    },
    watch: {

		// viewType: {
		// 	immediate: true,
		// 	handler: function () {
		// 	}
		// },
    },
    computed: {
        currentFields: function () {
            return this.viewType == 'entity' ? this.fields.filter(item => item.key == 'entity' ? false : true) : this.fields;
        }
    }
}
</script>